import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import {FormattedMessage} from "react-intl";

import priorityIcon from "../assets/priorty.svg";

function NotificationPriority({notification}) {
    return (
        <OverlayTrigger
            overlay={
                <Tooltip placement="top">
                    <FormattedMessage id="priority" /> :{" "}
                    {notification?.priority}
                </Tooltip>
            }>
            <i
                className="priority"
                style={
                    notification?.priority === "high"
                        ? {backgroundColor: "#FFB800"}
                        : notification?.priority === "normal"
                        ? {backgroundColor: "#0085FF"}
                        : notification?.priority === "low"
                        ? {backgroundColor: "#F00"}
                        : {backgroundColor: "#0085FF"}
                }>
                <img src={priorityIcon} alt="" />
            </i>
        </OverlayTrigger>
    );
}

export default NotificationPriority;
